import {
    CONFIRMED_GET_PROERTIES,
    CONFIRMED_GET_FILTERS,
    CONFIRMED_GET_PROPERTY,
    CONFIRMED_GET_REPORTED_ADS
} from '../actions/property/PropertyTypes';
const initialState = {
    properties: [],
    filters: {},
    property: {},
    reportedAds: [],
    loading: false,
};

function PropertyReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'SET_PROPERTY_LOADING':
            return {
                ...state,
                loading: actions.payload,
            };
        case CONFIRMED_GET_PROERTIES:
            return {
                ...state,
                properties: actions.payload,
                loading: false,
            };
        case CONFIRMED_GET_FILTERS:
            return {
                ...state,
                filters: actions.payload,
            };
        case CONFIRMED_GET_PROPERTY:
            return {
                ...state,
                property: actions.payload,
            };
        case CONFIRMED_GET_REPORTED_ADS:
            return {
                ...state,
                reportedAds: actions.payload,
            };
        default:
            return state;
    }
}

export { PropertyReducer };